/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros
Descripcion:        Logica para input tipo select
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/
import React, { Fragment } from 'react';

interface InputSelectProps {
    name: string,                   // id y name del input
    value: string,                  // valor actual del input
    options: InputSelectData,       // lista de opciones
    onChange: onChangeInput,        // funcion que se ejecuta al cambiar opcion elegida
    onBlur: onBlurInput,            // funcion que se ejecutar al salir del input
    addDefault?: boolean,           // indica si incluye opcion 'Seleccione'
    feedback?: string,              // mensaje de validacion del input
};

const InputSelect = (props:InputSelectProps) => {

    // controlar select
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();
        if (props.onChange) {
            const selectedValue = event.target.value;
            // Si el valor seleccionado es el valor por defecto, no se llama a onChange
            if (selectedValue !== "") {
                props.onChange(props.name, selectedValue || '');  // Usamos onChange original
            }
        }
    };

    // controlar salida
    const handleBlur = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (props.onBlur) {
            props.onBlur(props.name);
        }
    };

    const inputAttr = {
        name : props.name,
        value : props.value,
        onChange: handleChange,
        className : `form-control form-control-sm ${props.feedback && 'is-invalid'}`,
        onBlur: handleBlur,
    };

    // renderizar
    return (
        <Fragment>
            <select {...inputAttr}>
                {props.addDefault && 
                    <option value="">-- Seleccione --</option>
                }
                {props.options.map(op => 
                    <option key={op.id} value={op.id}>{op.text}</option>)
                }
            </select>
            {props.feedback &&
                <div className="invalid-feedback">{props.feedback}</div>
            }
        </Fragment>
    );
};

export default InputSelect;